/**
* A helper class responsible for retreiving configuration of the web defined in the index.html file using a json variable.
*/
import appState from "../state/AppStateContainer";

export class ConfigHelper {
  getConfigObject() {
    return window.siteConfig;
  }

  getBaseAPIPath() {
    const baseAPIPath = this.getConfigObject().appKeys.BaseAPIPath;
    if (baseAPIPath?.length) {
      return (baseAPIPath[baseAPIPath.length - 1] == '/') ? baseAPIPath : baseAPIPath + '/';
    }
    return '';
  }

  getOrgBasedUrl(apiUrl, params){
    const currentOrgUrl = appState._getCurrentOrgUrl();
    let orgUrl = currentOrgUrl || "/default";
    if(params?.orgSlug && !currentOrgUrl) orgUrl = `/${params.orgSlug}`;
    const concatUrl = "/api/organizations";
    // Don't transform URLs that already have /api/organizations or /api/v1
    if(apiUrl.startsWith(concatUrl) || apiUrl.startsWith("/api/v1")) return apiUrl;
    return apiUrl.replace("/api", `${concatUrl}${orgUrl}`);
  }
}

const configHelper = new ConfigHelper()
export default configHelper
